import React, {useMemo} from "react";
import {Button, ButtonProps, useTheme} from "@material-ui/core";
import {createCustomTheme} from "tools/theme";
import {blue, red} from "@material-ui/core/colors";
import {ThemeProvider} from "@material-ui/styles";

const RejectButton = ({children, ...props}: ButtonProps) => {
  const ambientTheme = useTheme();
  const primaryColor = ambientTheme?.palette?.primary?.main ?? blue.A400;
  const buttonTheme = useMemo(() => createCustomTheme(primaryColor, red[500]), [
    primaryColor,
  ]);

  return (
    <ThemeProvider theme={buttonTheme}>
      <Button {...props}>{children}</Button>
    </ThemeProvider>
  );
};

export default RejectButton;
